import $ from "jquery";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class EditQuantity extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;

        var articles = Comm.Articles(sid, true);
        var contragents = Comm.Partners(sid);
        contragents.unshift({ id: -1, name: "---" });

        this.state = {
            Articles: articles,
            Contragents: contragents,
            SelectedArticle: null,
        };

        this.Save = this.Save.bind(this);
        this.Add = this.Add.bind(this);
        this.Cancel = this.Cancel.bind(this);
        this.Sub = this.Sub.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var articles = this.state.Articles.slice();

        var self = this;

        return Context.HasRight("reditquantity") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("editquantities")}</div>
                <div className="panel-body">
                    <div className="row">
                        {this.state.SelectedArticle === null ? (
                            <div className="col-md-12">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th width="30%">{Translation.Trans("code")}</th>
                                            <th width="30%">{Translation.Trans("name")}</th>
                                            <th width="30%">{Translation.Trans("inputarticle")}</th>
                                            <th width="10%">{Translation.Trans("quantity")}</th>
                                        </tr>
                                    </thead>
                                </table>
                                <div className="scrollableDiv">
                                    <table className="table table-striped">
                                        <tbody>
                                            {articles.map((obj) => (
                                                <tr>
                                                    <td width="30%">
                                                        <span
                                                            className={
                                                                this.state.SelectedArticle !== null &&
                                                                this.state.SelectedArticle.id === obj.id
                                                                    ? "btn btn-warning"
                                                                    : null
                                                            }
                                                        >
                                                            <a
                                                                onClick={() => self.EditArticle(obj)}
                                                                className="pointhand"
                                                            >
                                                                {obj.code}
                                                            </a>
                                                        </span>
                                                    </td>
                                                    <td width="30%">{obj.name}</td>
                                                    <td width="30%">
                                                        {obj.is_input ? (
                                                            <i className="fa fa-check" aria-hidden="true"></i>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>
                                                    <td width="10%" align="right">
                                                        {obj.qty}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : null}
                        {this.state.SelectedArticle !== null ? (
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">
                                            {Translation.Trans("currentquantity")}
                                        </label>
                                    </div>
                                    <div className="col-md-10">{this.state.SelectedArticle.qty}</div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">
                                            {Translation.Trans("newquantity")}
                                        </label>
                                    </div>
                                    <div className="col-md-10">
                                        <input
                                            type="number"
                                            id="tbNewQuantity"
                                            className="form-control"
                                            key={"newquantity" + this.state.SelectedArticle.id}
                                            defaultValue="0"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="control-label">
                                            {Translation.Trans("contragent")}
                                        </label>
                                    </div>
                                    <div className="col-md-10">
                                        <select id="ddlContragent" className="form-control">
                                            {this.state.Contragents.map((item) => (
                                                <option value={item.id}>{item.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                {Context.HasRight("eeditquantity") ? (
                                    <div className="row">
                                        <div className="col-md-4">
                                            <button className="btn btn-primary" onClick={this.Cancel}>
                                                {Translation.Trans("cancel")}
                                            </button>
                                        </div>
                                        <div className="col-md-4">
                                            <button className="btn btn-primary" onClick={this.Add}>
                                                {Translation.Trans("add")}
                                            </button>
                                        </div>
                                        <div className="col-md-4">
                                            <button className="btn btn-primary pull-right" onClick={this.Sub}>
                                                {Translation.Trans("subtract")}
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        ) : null;
    }

    EditArticle(article) {
        this.setState({ SelectedArticle: article });
    }

    Add() {
        this.Save(true);
    }
    Cancel() {
        this.setState({
            SelectedArticle: null,
            showMissingCodeError: false,
            showMissingNameError: false,
        });
    }

    Sub() {
        this.Save(false);
    }

    Save(add) {
        var quantity = $("#tbNewQuantity").val();
        var contragent = $("#ddlContragent").val();

        var q = parseFloat(quantity) || 0;

        var data = {};
        data.article = this.state.SelectedArticle.id;
        if (contragent !== -1) data.partner = contragent;
        data.qty = q;
        if (!add) data.qty = -data.qty;
        var sid = Context.GetContext().Sid;
        data.session = sid;

        Comm.SaveArticleQuantity(data);

        var articles = Comm.Articles(sid, true);

        this.setState({
            Articles: articles,
            SelectedArticle: null,
            showMissingCodeError: false,
            showMissingNameError: false,
        });
    }
}

export default EditQuantity;



// WEBPACK FOOTER //
// ./src/pages/editquantity.js